module.exports = __webpack_public_path__ + "static/media/uniform_male_front.661bcf91.png";